<section>
  <div class="header d-none d-md-block">
    <h1 class="d-inline-block v-align-middle">{{ 'COOPERATIVE_HOUSING.TRANSFER_LIST_HEADER' | translate }}</h1>
  </div>
  <div class="header d-flex d-md-none align-items-center">
    <h1 class="w-100">{{ 'INCORRECT_PAYMENT.LIST_HEADER' | translate }}</h1>
  </div>
  <app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>
  <app-multiselect-list-view
    [columnDefinition]="columnDefinition"
    [itemsSource]="itemsSource"
    [contextMenuDefinition]="contextMenuDefinition"
    [menuDefinition]="menuDefinition"
    [preferencesKey]="preferencesKey"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
  >
  </app-multiselect-list-view>
</section>
